import type { ITranslatedSlug } from '@/components/types'
import { ISO_DATE_FORMAT } from '@/utils/constants/date'
import type { IStoryblokPageData } from '@/stores/types'

export const useMetaTags = (pageStory: Ref<IStoryblokPageData | null>) => {
  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()
  const { locale } = useI18n()

  if (!pageStory.value) {
    return
  }

  const seoContent = pageStory.value?.content?.seo

  if (seoContent) {
    useSeoMeta({
      title: seoContent?.title,
      description: seoContent?.description,
      ogSiteName: 'airBaltic.com'
    })
  }

  useRobotsRule(true)

  useHead(() => {
    const links = [
      {
        rel: 'canonical',
        href: runtimeConfig.public.siteUrl + trimLastSlash(route.path)
      },
      {
        rel: 'alternate',
        hreflang: 'x-default',
        href: runtimeConfig.public.siteUrl + '/en/' + trimLastSlash(pageStory.value?.default_full_slug ?? '')
      }
    ]

    const translatedSlugs = pageStory.value?.translated_slugs
    if (translatedSlugs) {
      translatedSlugs.forEach((slug: ITranslatedSlug) => {
        if (!slug?.name) return

        links.push({
          rel: 'alternate',
          hreflang: slug.lang,
          href: runtimeConfig.public.siteUrl + '/' + slug.lang + '/' + trimLastSlash(slug.path ?? '')
        })
      })
    }

    const dayjs = useDayjs()

    const lastModified = pageStory.value?.updated_at ? dayjs(pageStory.value.updated_at).format(ISO_DATE_FORMAT) : ''

    return {
      meta: [
        {
          name: 'language',
          content: locale.value
        },
        {
          name: 'lastModified',
          content: lastModified
        }
      ],
      link: links
    }
  })
}
